export const locales = ['uk', 'en'];
export const defaultLocale = 'uk';
